__turbopack_context__.v({
  "unorderedList": "PersonalDetails-module__H6l3bG__unorderedList",
});
